import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormCompletion } from "../Context/FormCompletionContext";
import Select from "react-select";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? "#551e19" : provided.borderColor,
    boxShadow: state.isFocused ? "0 0 0 1px #551e19" : provided.boxShadow,
    borderRadius: '0.375rem',
    padding: '0.15rem',
    "&:hover": {
      borderColor: state.isFocused
        ? "#551e19"
        : provided["&:hover"].borderColor,
    },
  }),
};

const DeliveryInfoForm = () => {
  const { markFormAsCompleted, saveFormData, formData } = useFormCompletion();
  const navigate = useNavigate();
  const [newFormData, setNewFormData] = useState({
    houseNumber: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    district: "",
    province: "",
    postalCode: "",
  });

  const districts = [
    { label: "Ampara", value: "Ampara" },
    { label: "Anuradhapura", value: "Anuradhapura" },
    { label: "Badulla", value: "Badulla" },
    { label: "Batticaloa", value: "Batticaloa" },
    { label: "Colombo", value: "Colombo" },
    { label: "Galle", value: "Galle" },
    { label: "Gampaha", value: "Gampaha" },
    { label: "Hambantota", value: "Hambantota" },
    { label: "Jaffna", value: "Jaffna" },
    { label: "Kalutara", value: "Kalutara" },
    { label: "Kandy", value: "Kandy" },
    { label: "Kegalle", value: "Kegalle" },
    { label: "Kilinochchi", value: "Kilinochchi" },
    { label: "Kurunegala", value: "Kurunegala" },
    { label: "Mannar", value: "Mannar" },
    { label: "Matale", value: "Matale" },
    { label: "Matara", value: "Matara" },
    { label: "Monaragala", value: "Monaragala" },
    { label: "Mullaitivu", value: "Mullaitivu" },
    { label: "Nuwara Eliya", value: "Nuwara Eliya" },
    { label: "Polonnaruwa", value: "Polonnaruwa" },
    { label: "Puttalam", value: "Puttalam" },
    { label: "Rathnapura", value: "Rathnapura" },
    { label: "Trincomalee", value: "Trincomalee" },
    { label: "Vavuniya", value: "Vavuniya" },
  ];

  const handleDistrictChange = (selectedOption) => {
    setNewFormData((prevFormData) => ({
      ...prevFormData,
      district: selectedOption ? selectedOption.value : "",
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      district: "",
    }));
  };

  const [errors, setErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);

  // Handle input change
  const handleChange = (event) => {
    const { name, value } = event.target;
    setNewFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    // Clear errors as the user types
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  // Validate individual fields
  const validateField = (name, value) => {
    if (!value && name !== "addressLine2") {
      return "This field is required.";
    }
    if (name === "postalCode" && !/^\d{5}$/.test(value)) {
      return "Postal Code must be 5 digits.";
    }
    return "";
  };

  // Validate the entire form
  const validateForm = () => {
    const newErrors = {};
    Object.keys(newFormData).forEach((key) => {
      // Skip validation for addressLine2
      if (key !== "addressLine2") {
        const error = validateField(key, newFormData[key]);
        if (error) newErrors[key] = error;
      } else if (newFormData[key]) {
        // If addressLine2 is filled out, validate it
        const error = validateField(key, newFormData[key]);
        if (error) newErrors[key] = error;
      }
    });
    setErrors(newErrors);
    setIsFormValid(Object.keys(newErrors).length === 0);
  };

  // UseEffect to load saved data into the form fields
  useEffect(() => {
    if (formData.delivery_details) {
      const savedData = formData.delivery_details;
      setNewFormData((prevFormData) => ({
        ...prevFormData,
        ...savedData,
      }));
    }
  }, [formData.delivery_details]);

  // Trigger validation when form data changes
  useEffect(() => {
    validateForm();
  }, [newFormData]);

  // Handle form submission
  const onSubmit = (event) => {
    event.preventDefault();
    validateForm();
    if (!isFormValid) return;

    saveFormData("delivery_details", newFormData);
    markFormAsCompleted("confirm_details");
    navigate("/order/confirm_details");
  };

  return (
    <div className="col-span-2">
      <h2 className="text-xl font-semibold text-[#551E19] mb-4">
        Delivery Address
      </h2>
      <form
        className="grid grid-cols-1 sm:grid-cols-2 gap-6"
        onSubmit={onSubmit}
      >
        {[
          { name: "houseNumber", label: "House Number", type: "text" },
          { name: "addressLine1", label: "Address Line 1", type: "text" },
          { name: "addressLine2", label: "Address Line 2", type: "text" },
          { name: "city", label: "City", type: "text" },
          { name: "district", label: "District", type: "select" },
          { name: "postalCode", label: "Postal Code", type: "text" },
          { name: "province", label: "Province", type: "text" },
        ].map((field, index) => (
          <div key={index} className="relative">
            <label className="block mb-1 text-sm">{field.label}</label>
            {field.type === "select" ? (
              // <select
              //   name={field.name}
              //   value={newFormData[field.name]}
              //   onChange={handleChange}
              //   className="w-full p-2 border rounded-md focus:outline-none focus:ring-[#551E19] focus:ring-1 bg-white text-gray-700"
              // >
              //   <option value="">Please Select</option>
              //   <option value="District 1">District 1</option>
              //   <option value="District 2">District 2</option>
              // </select>
              <Select
                name={field.name}
                value={districts.find(
                  (district) => district.value === newFormData[field.name]
                )}
                onChange={handleDistrictChange}
                options={districts}
                isSearchable
                className="w-full"
                styles={customStyles}
              />
            ) : (
              <input
                type={field.type}
                name={field.name}
                value={newFormData[field.name]}
                onChange={handleChange}
                onBlur={() =>
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    [field.name]: validateField(
                      field.name,
                      newFormData[field.name]
                    ),
                  }))
                }
                className="w-full p-2 border rounded-md focus:outline-none focus:ring-[#551E19] focus:ring-1"
              />
            )}
            {errors[field.name] && (
              <span className="text-red-500 text-[8px] mt-1 absolute left-0 top-full">
                {errors[field.name]}
              </span>
            )}
          </div>
        ))}

        <button
          type="submit"
          className={`col-span-1 sm:col-span-2 bg-[#f7c89c] text-white font-semibold py-2 rounded-full hover:bg-[#efad70] transition max-w-max px-8 mx-auto mt-5 ${
            !isFormValid ? "opacity-50 cursor-not-allowed" : ""
          }`}
          disabled={!isFormValid}
        >
          CONTINUE
        </button>
      </form>
    </div>
  );
};

export default DeliveryInfoForm;
